const Hdata=[
    {
    "id": 1,
    "img":"https://html.dynamiclayers.net/dl/news24/img/health-1.jpg",
    "title": "The future of possible innovation for business company.",
    "category": "1",
    },
    {
    "id": 2,
    "img":"https://html.dynamiclayers.net/dl/news24/img/health-2.jpg",
    "title": "The future of possible innovation for business company.",
    "category": "2",
    },
    {
    "id": 3,
    "img":"https://html.dynamiclayers.net/dl/news24/img/health-3.jpg",
    "title": "The future of possible innovation for business company.",
    "category": "3",
    },
    {
        "id": 4,
        "img":"https://html.dynamiclayers.net/dl/news24/img/health-4.jpg",
        "title": "The future of possible innovation for business company.",
        "category": "4",
        },
        {
            "id": 5,
            "img":"https://html.dynamiclayers.net/dl/news24/img/health-5.jpg",
            "title": "The future of possible innovation for business company.",
            "category": "5",
            },
            {
            "id": 6,
            "img":"https://html.dynamiclayers.net/dl/news24/img/health-6.jpg",
            "title": "The future of possible innovation for business company.",
            "category": "6",
            },
            {
            "id": 7,
            "img":"https://html.dynamiclayers.net/dl/news24/img/health-7.jpg",
            "title": "The future of possible innovation for business company.",
            "category": "7",
            },
            {
                "id": 8,
                "img":"https://html.dynamiclayers.net/dl/news24/img/health-8.jpg",
                "title": "The future of possible innovation for business company.",
                "category": "8",
                },
]
export default Hdata;